
function MapWassertirol() {
    /// <summary>
    /// This object provides client-side functions for the Map/Wassertirol/Map.vb <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 22.11.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 22.11.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}

MapWassertirol.prototype = new vcTemplate();

MapWassertirol.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false); 
        me.visual.find("#div-frame").html("<iframe onload='resizeIframe(this)' src='" + me.url + "' style='border:none;width:100%'></iframe>");
      
        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

MapWassertirol.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-frame').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

